// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__YImcG","copyTasksButton":"styles_copyTasksButton__3Jmc2","tasksContainer":"styles_tasksContainer__1jsnh"};